var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotate90(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1324_31133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73319 16.4696L2.72221 14.2434C1.0464 12.3882 1.11814 10.9758 2.97331 9.29998L5.19951 7.289C7.05467 5.61318 8.46707 5.68492 10.1429 7.54009L12.1539 9.76629C13.8297 11.6215 13.7579 13.0339 11.9028 14.7097L9.67657 16.7206C7.8214 18.3965 6.40901 18.3247 4.73319 16.4696Z",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51327 4.07311C4.91679 2.05626 8.12363 1.86675 10.6851 3.64928M10.6851 3.64928L9.35546 4.07766M10.6851 3.64928L10 1.50003",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1324_31133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18.727,
    fill: "white",
    transform: "matrix(-1 0 0 1 14.5 0.636505)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate90);
export default __webpack_public_path__ + "static/media/rotate-90.99eb2d583b41f15b9d4d9cfe4bd37e8e.svg";
export { ForwardRef as ReactComponent };